<h1 mat-dialog-title>{{ 'dialogs.manualAddress.title' | translate }}</h1>

<mat-dialog-content class="mb-3">
  <div class="alert alert-info alert-dismissible" role="alert">
    {{ 'dialogs.manualAddress.message' | translate }}
  </div> <!-- /.alert -->
  <app-card-spinner [visible]="dialogIsLoading" type="zero"></app-card-spinner>
  <div class="form-wrapper mt-3">
    <form [formGroup]="form">
      <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
    </form>
  </div> <!-- /.form-wrapper -->
</mat-dialog-content> <!-- mat-dialog-content -->

<mat-dialog-actions>
  <div style="width: 50%;">
    <button mat-raised-button color="accent" (click)="onGetGeocoding()" 
      [disabled]="geocodingDisabled">
      <mat-icon fontSet="fal" fontIcon="fa-location-dot"></mat-icon>
      {{ 'dialogs.manualAddress.btnGeocoding' | translate }}
    </button>
  </div>
  <div style="width: 46%; text-align: right;">
    <a mat-raised-button [color]="data.btnCancelColor" (click)="onDenial()">
      <mat-icon fontSet="fal" [fontIcon]="data.btnCancelIcon"></mat-icon>
      {{ 'common.cta.undo' | translate }}
    </a>
    <button mat-raised-button [color]="data.btnOkColor" (click)="onConfirm()">
      <mat-icon fontSet="fal" [fontIcon]="data.btnOkIcon"></mat-icon>
      {{ 'common.cta.save' | translate }}
    </button>
  </div>
</mat-dialog-actions> <!-- /.mat-dialog-actions -->
